import kalapostAPI, { getErrorType } from './httpService';

export const GetTrakingSerivece = async (trackingNumber, token) => {
   try {
      return await kalapostAPI.get('track', {
         params: { trackingNumber },
         headers: { 'g-recaptcha-response': token },
      });
   } catch (error) {
      return getErrorType(error);
      // return trackingNumber && getErrorType(error);
   }
};

export const getPreDataService = async (pageType) => {
   try {
      return await kalapostAPI.get('predata', {
         params: {
            page: pageType,
         },
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetGeneralUserService = async (addService) => {
   try {
      return await kalapostAPI.get(`generalpredata`, {
         params: {
            page: addService,
         },
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const CheckPhoneNumberService = async (phoneNumber, token) => {
   try {
      return await kalapostAPI.post(
         'uniquephonenumber',
         { phoneNumber },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetAgentService = async () => {
   try {
      return await kalapostAPI.get('branch');
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetStatesService = async () => {
   try {
      return await kalapostAPI.get('states');
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetUserStatesService = async (id, token) => {
   try {
      return await kalapostAPI.get('states', {
         params: { stateId: id },
         headers: { 'g-recaptcha-response': token },
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetCitesService = async (id, token) => {
   try {
      return await kalapostAPI.get('locations', {
         params: { stateId: id },
         headers: { 'g-recaptcha-response': token },
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetGeneralCitesService = async (id, token) => {
   try {
      return await kalapostAPI.get('generallocations', {
         params: { stateId: id },
         headers: { 'g-recaptcha-response': token },
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const PostComplaintService = async (
   firstName,
   lastName,
   subject,
   text,
   phoneNumber,
   token
) => {
   try {
      return await kalapostAPI.post(
         'complaint',
         {
            firstName,
            lastName,
            subject,
            text,
            phoneNumber,
         },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetUserInfoService = async () => {
   try {
      return await kalapostAPI.get('user');
   } catch (error) {
      return getErrorType(error);
   }
};

export const PatchUserService = async (
   { fullName, phoneNumber, cityId, address, postalCode, email },
   token
) => {
   try {
      return await kalapostAPI.patch(
         'user',
         {
            fullName,
            phoneNumber,
            cityId,
            address,
            postalCode,
            email,
         },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
      // return getErrorType(error);
   }
};

export const PatchUserPasswordService = async ({ password }, token) => {
   try {
      return await kalapostAPI.patch(
         'password',
         { password },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};
export const forgetPasswordService = async (phoneNumber, password, code, tokenCode, token) => {
   try {
      return await kalapostAPI.put(
         'generalPassword',
         { phoneNumber, password, code, tokenCode },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetUserServicesSevice = async (type) => {
   try {
      return await kalapostAPI.get('services', { params: { category: type } });
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetUserDetailsService = async (trackingNumber, token) => {
   try {
      return await kalapostAPI.get('service', {
         params: { trackingNumber },
         headers: { 'g-recaptcha-response': token },
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetReportService = async (trackingNumber) => {
   try {
      return await kalapostAPI.get('reportService', {
         params: { trackingNumber },
         responseType: 'blob',
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetDesCitiesService = async (stateId, token) => {
   try {
      return await kalapostAPI.get('generallocations', {
         params: { stateId },
         headers: { 'g-recaptcha-response': token },
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const PostEstimateService = async (
   packages,
   packing,
   origin,
   destination,
   deliveryTypeId,
   assurance,
   token
) => {
   try {
      return await kalapostAPI.post(
         'generalPrice',
         {
            packages,
            packing,
            origin,
            destination,
            deliveryTypeId,
            assurance,
         },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const GetConfirmLocationService = async (token, recaptchaToken) => {
   try {
      return await kalapostAPI.get('confirmLocation', {
         headers: { 'g-recaptcha-response': recaptchaToken },
         params: { token },
      });
   } catch (error) {
      return getErrorType(error);
   }
};
export const postConfirmLocationService = async (data, recaptchaToken) => {
   try {
      return await kalapostAPI.post('confirmLocation', data, {
         headers: { 'g-recaptcha-response': recaptchaToken },
      });
   } catch (error) {
      return getErrorType(error);
   }
};

export const putConfirmLocationSerice = async (lat, lng, locationId, token) => {
   try {
      return await kalapostAPI.put(
         `confirmLocation`,
         { originLat: lat, originLng: lng, token: locationId },
         { headers: { 'g-recaptcha-response': token } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};

export const timeEstimationService = async (origin, destination, recaptchaToken) => {
   try {
      return await kalapostAPI.post(
         'GeneraldistanceCity',
         { origin, destination },
         { headers: { 'g-recaptcha-response': recaptchaToken } }
      );
   } catch (error) {
      return getErrorType(error);
   }
};
